<template>
  <div class="kanban-toolbar">
    <div class="toolbar-group">
      <label for="kanban-search">Buscar</label>
      <input
        id="kanban-search"
        type="text"
        :value="searchQuery"
        placeholder="Buscar por titulo, descripcion o proyecto"
        @input="$emit('update:searchQuery', $event.target.value)"
      />
    </div>

    <div class="toolbar-group">
      <label for="kanban-project">Proyecto</label>
      <select
        id="kanban-project"
        :value="selectedProjectId"
        @change="$emit('update:selectedProjectId', castValue($event.target.value))"
      >
        <option :value="null">Todos</option>
        <option v-for="project in projects" :key="project.id" :value="project.id">
          {{ project.name }}
        </option>
      </select>
    </div>

    <div class="toolbar-group">
      <label for="kanban-tag">Tag</label>
      <select
        id="kanban-tag"
        :value="selectedTag"
        @change="$emit('update:selectedTag', $event.target.value)"
      >
        <option value="">Todos</option>
        <option v-for="tag in availableTags" :key="tag" :value="tag">
          {{ tag }}
        </option>
      </select>
    </div>

    <div class="toolbar-group">
      <label for="kanban-priority">Prioridad</label>
      <select
        id="kanban-priority"
        :value="selectedPriority"
        @change="$emit('update:selectedPriority', $event.target.value)"
      >
        <option value="all">Todas</option>
        <option value="high">Alta</option>
        <option value="medium">Media</option>
        <option value="low">Baja</option>
      </select>
    </div>

    <div class="toolbar-group">
      <label for="kanban-date">Fecha</label>
      <select
        id="kanban-date"
        :value="dateFilter"
        @change="$emit('update:dateFilter', $event.target.value)"
      >
        <option value="any">Todas</option>
        <option value="overdue">Vencidas</option>
        <option value="today">Hoy</option>
        <option value="week">Esta semana</option>
        <option value="nodate">Sin fecha</option>
      </select>
    </div>

    <div class="toolbar-group">
      <label for="kanban-sort">Orden</label>
      <select
        id="kanban-sort"
        :value="sortMode"
        @change="$emit('update:sortMode', $event.target.value)"
      >
        <option value="manual">Manual</option>
        <option value="updated">Actualizadas</option>
        <option value="due">Fecha limite</option>
        <option value="priority">Prioridad</option>
      </select>
    </div>

    <div v-if="activeFilters.length" class="toolbar-state">
      <span class="state-label">Activos</span>
      <button
        v-for="filter in activeFilters"
        :key="filter.key"
        class="filter-chip"
        type="button"
        @click="$emit('clear-filter', filter)"
      >
        {{ filter.label }}
      </button>
      <button class="ghost tiny" type="button" @click="$emit('clear-filters')">
        Limpiar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "KanbanToolbar",
  props: {
    searchQuery: { type: String, default: "" },
    projects: { type: Array, default: () => [] },
    selectedProjectId: { type: [String, Number, null], default: null },
    availableTags: { type: Array, default: () => [] },
    selectedTag: { type: String, default: "" },
    selectedPriority: { type: String, default: "all" },
    dateFilter: { type: String, default: "any" },
    sortMode: { type: String, default: "manual" },
    activeFilters: { type: Array, default: () => [] },
  },
  emits: [
    "update:searchQuery",
    "update:selectedProjectId",
    "update:selectedTag",
    "update:selectedPriority",
    "update:dateFilter",
    "update:sortMode",
    "clear-filter",
    "clear-filters",
  ],
  methods: {
    castValue(value) {
      if (value === "null" || value === "") return null;
      return value;
    },
  },
};
</script>

<style scoped>
.kanban-toolbar {
  display: grid;
  gap: 12px;
  padding: 14px;
  background: rgba(12, 18, 32, 0.7);
  border: 1px solid var(--border);
  border-radius: 16px;
  backdrop-filter: blur(12px);
}

.toolbar-group {
  display: grid;
  gap: 6px;
  min-width: 0;
}

.toolbar-group label {
  font-size: 12px;
  color: var(--muted);
  letter-spacing: 0.02em;
}

.toolbar-group input,
.toolbar-group select {
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 8px 10px;
  color: var(--text);
  width: 100%;
}

.toolbar-state {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.state-label {
  font-size: 11px;
  color: var(--muted);
}

.filter-chip {
  background: rgba(56, 189, 248, 0.12);
  border: 1px solid rgba(56, 189, 248, 0.35);
  color: var(--text);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11px;
  cursor: pointer;
}

.ghost {
  background: rgba(148, 163, 184, 0.12);
  border: 1px solid rgba(148, 163, 184, 0.25);
  color: var(--text);
  border-radius: 999px;
  cursor: pointer;
  font-weight: 600;
}

.ghost.tiny {
  padding: 6px 10px;
  font-size: 11px;
  border-radius: 999px;
}

@media (min-width: 960px) {
  .kanban-toolbar {
    grid-template-columns: repeat(6, minmax(140px, 1fr));
    align-items: end;
  }

  .toolbar-state {
    grid-column: 1 / -1;
  }
}
</style>
